<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="table_data.search"/>
      <v-btn class="ml-3 box-shadow" color="primary" :to="{name: 'Edit study invite members', params: $route.params}">
        Invite new
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="table_data.search">
          <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" class="box-shadow" @click="openSelectedItemDialog(item)">
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
            <v-btn small color="primary" class="box-shadow" :to="{name: 'Student', params: {student_id: item.user_id}}">
              <v-icon small>mdi-account</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="600px">
      <v-card>
        <v-toolbar dark dense color="primary">
          Settings
          <v-spacer></v-spacer>
          <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text v-if="study_group && selected_item">

          <v-select label="Sub group"
                    v-model="selected_item.study_sub_group_id"
                    :items="study_group.study_sub_groups"
                    item-value="id"
                    item-text="p1_exam_dates"
          >
            <template v-slot:item="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
            </template>

            <template v-slot:selection="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
            </template>
          </v-select>


          <v-select label="Visitation type"
                    v-model="selected_item.visitation_type"
                    :items="visitation_type_opts"
                    item-value="value"
                    item-text="text"
          ></v-select>

          <v-switch label="Is Sunday day off?" v-model="selected_item.sunday_day_off"/>

          <DateField label="Training start" v-model="selected_item.training_start"/>

          <DateField label="Training end" v-model="selected_item.training_end"/>

          <v-textarea v-model="selected_item.summary" color="primary" class="my-0"
                      label="Motivation letter" outlined disabled
          ></v-textarea>

          <v-select label="Status"
                    v-model="selected_item.status"
                    :items="status_options"
                    item-text="label"
                    item-value="value"
                    outlined
          ></v-select>

        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="destroySelectedItem">Remove</v-btn>
          <v-btn color="primary" @click="updateSelectedItem">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import DateField from "@/components/DateField";
export default {
  components: {DateField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    table_data: {
      headers: [
        { text: 'Name', value: 'user.full_name'},
        { text: 'Email', value: 'user.email'},
        { text: 'Sub group', value: 'study_sub_group.name'},
        { text: 'VT', value: 'visitation_type'},
        { text: 'Sun day off', value: 'sunday_day_off'},
        { text: 'Training start', value: 'training_start'},
        { text: 'Training end', value: 'training_end'},
        { text: 'Status', value: 'status'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: ''
    },
    selected_item: null,
    selected_item_dialog: false,
    status_options: [
      { value: 'invited', label: 'Invited'},
      { value: 'requested', label: 'Requested'},
      { value: 'approved', label: 'Approved'},
    ],
    visitation_type_opts: [
      {text: 'G1 - workday group', value: 'G1'},
      {text: 'G2 - weekend group', value: 'G2'},
      {text: 'G3 - mix group', value: 'G3'},
    ],
    api_errors: []
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/study-groups/${this.$route.params.study_group_id}/clients`)
          .then(({data}) => data.data)
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
      this.api_errors = []
    },
    updateSelectedItem() {
      this.app_loading = true
      this.axios.put(`api/study-groups/${this.$route.params.study_group_id}/clients/${this.selected_item.id}`, this.selected_item)
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {
            this.app_loading = false
          })
    },
    destroySelectedItem() {
      this.app_loading = true
      this.axios.delete(`api/study-groups/${this.$route.params.study_group_id}/clients/${this.selected_item.id}`)
          .then(() => {
            this.closeSelectedItemDialog()
            this.loadData()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },

  }
}
</script>